import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    state: { isFavouriteLoading },
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [sources, setSources] = useParameter<string[]>("@sources");
  const [commodities, setCommodities] = useParameter<number>("@commodities");
  const [commodityDisplay, setCommodityDisplay] = useParameter<number>("@commodities_display");

  useEffect(() => {
    setParameters(title, {
      "@sources": sources,
      "@commodities": commodities,
      "@commodities_display": commodityDisplay,
    });
  }, [title, sources, commodities, commodityDisplay, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, (number | string)[]>) => {
      setSources(parameters["@sources"] as string[]);
      setCommodities(parameters["@commodities"].map(Number)[0]);
      setCommodityDisplay(parameters["@commodities_display"].map(Number)[0]);
    },
    [setSources, setCommodities, setCommodityDisplay]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);

  return { isFavouriteLoading };
}
